import styled from 'styled-components'

import AccountInfo from './components/AccountInfo'

const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 2rem;

`

const Main = styled.main`
  height: 100vh;
  width: 100vw;
  text-align: center;

  @media(min-width: 1010px) {
    width: 50vw;
  }
`

const Header = styled.h1`
  color: #fff;
  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.15);
`

function App() {
  return (
    <Wrapper>
      <Main>
        <Header>Check account info</Header>
        <AccountInfo />
      </Main>
    </Wrapper>
  )
}

export default App
